import { Component } from 'react';
import PropTypes from 'prop-types';

import { difference } from 'lodash';

class SyncComponent extends Component {
  static propTypes = {
    channels: PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ])).isRequired,
    uniqueKey: PropTypes.string.isRequired,
    onGetMessage: PropTypes.func.isRequired,
    messageHandler: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    props.messageHandler(this.sendMessage);
    this.timestamp = new Date().getTime();
  }

  componentWillReceiveProps(nextProps) {
    const unsubscribeChannels = difference(this.props.channels, nextProps.channels);
    const subscribeChannels = difference(nextProps.channels, this.props.channels);
    window.pubnub && window.pubnub.unsubscribe({
      channels: unsubscribeChannels.map(channel => `${nextProps.uniqueKey}-${channel}`),
    });

    const channels = subscribeChannels.map(channel => `${nextProps.uniqueKey}-${channel}`);
    window.pubnub && window.pubnub.subscribe({
      channels,
      withPresence: false,
    });

    subscribeChannels.forEach((channel) => {
      const channelName = `${nextProps.uniqueKey}-${channel}`;
      window.pubnub && window.pubnub.getMessage(
        channelName,
        (msg) => {
          if (msg.timetoken / 10000 > this.timestamp) {
            this.props.onGetMessage(channel, msg.message);
          }
        });
    });
  }

  componentWillUnmount() {
    window.pubnub && window.pubnub.unsubscribe({
      channels: this.props.channels.map(channel => `${this.props.uniqueKey}-${channel}`),
    });
  }

  sendMessage = (channel, message) => {
    try {
      window.pubnub && window.pubnub.publish({
        message,
        channel: `${this.props.uniqueKey}-${channel}`,
      });
    } catch (e) {
      console.debug(e);
    }
  }

  render() {
    return null;
  }
}

export default SyncComponent;
